

<div id="reset-password" fxLayout="column">

    <div id="reset-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="reset-password-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo"> 
                <img src="assets/img/logofirma.png">
            </div>

            <div class="title" *ngIf="!enlaceExiste">
                Lamentablemente, el enlace indicado NO EXISTE o ESTA CADUCADO
            </div>
            

            <div class="title"  *ngIf="enlaceExiste">RESETEAR CONTRASEÑA</div>

            <form name="resetPasswordForm" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate  *ngIf="enlaceExiste">
    
                <!--
                     <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="resetPasswordForm.get('email').hasError('required')">
                        Email is required
                    </mat-error>
                    <mat-error *ngIf="resetPasswordForm.get('email').hasError('email')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>
                -->
               

                <mat-form-field appearance="outline">
                    <mat-label>Contraseña</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        Se requiere una contraseña
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Confirmar Contraseña</mat-label>
                    <input matInput type="password" formControlName="passwordConfirm">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error *ngIf="resetPasswordForm.get('passwordConfirm').hasError('required')">
                        Se requiere confirmar la contraseña
                    </mat-error>
                    <mat-error *ngIf="!resetPasswordForm.get('passwordConfirm').hasError('required') &&
                                       resetPasswordForm.get('passwordConfirm').hasError('passwordsNotMatching')">
                        ¡¡ Las contraseñas no coinciden !!
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button class="submit-button" color="accent"
                        aria-label="RESET MY PASSWORD" [disabled]="resetPasswordForm.invalid">
                    Cambiar Contraseña
                </button>
            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/pages/auth/login'">Ir al inicio</a>
            </div>

        </div>

    </div>

</div>
